import {Tooltip} from 'antd';
import styled from 'styled-components';
import {InfoCircleOutlined} from '@ant-design/icons';

export const StyledTooltip = styled(Tooltip)``;
export const TooltipIcon = styled(InfoCircleOutlined)`
  color: ${({theme}) => theme.palette.common.brown};
`;
